// Home page hero text that super admin can change in Landing CMS > Hero.
// An empty field means "use the designed copy". Text that older versions saved as the default
// ("India's #1 Coaching Institute Platform", "Get Started Free") counts as empty, so it never
// reaches the site unless someone types it in again.

export const DESIGN_COPY = {
  hero_title: 'Run your institute like a premium brand.',
  hero_subtitle: 'One app for fees, attendance, admissions, exams and parents. Biometric punches reach parents on WhatsApp, fee reminders go out with a pay link, and an AI agent calls every new enquiry.',
  hero_cta_primary: 'Start Free Trial',
  hero_cta_secondary: 'Book Free 1-on-1 Demo',
};

const LEGACY_DEFAULTS = {
  hero_title: ["India's #1 Coaching Institute Platform", 'Coaching Institute Management Platform'],
  hero_subtitle: ['Manage your coaching institute with AI-powered tools. From admissions to results - everything in one place.'],
  hero_cta_primary: ['Get Started Free'],
  hero_cta_secondary: ['Book a Demo'],
};

const normalize = (text) => String(text || '').toLowerCase().replace(/[–—-]/g, '-').replace(/\s+/g, ' ').trim();

// The admin's own text for a hero field, or '' when the designed copy should show
export const customCopy = (config, key) => {
  const value = String(config?.[key] || '').trim();
  if (!value) return '';
  return (LEGACY_DEFAULTS[key] || []).some((legacy) => normalize(legacy) === normalize(value)) ? '' : value;
};

// Landing CMS form state: legacy defaults show as empty fields with the designed copy as placeholder
export const withoutLegacyDefaults = (config) => (config
  ? Object.keys(DESIGN_COPY).reduce((next, key) => ({ ...next, [key]: customCopy(config, key) }), { ...config })
  : config);
